import { addProtocol } from 'maplibre-gl'
import { Protocol } from 'pmtiles'

let initialized = false

/**
 * MapLibre GL に pmtiles:// プロトコルを登録する。
 * 2回呼び出されても1回だけ登録する（冪等）。
 *
 * 使用方法:
 * ```
 * // pages/_app.tsx（モジュールトップレベル）
 * import { initPmtilesProtocol } from '@/lib/map/initPmtilesProtocol'
 * initPmtilesProtocol()
 * ```
 */
export function initPmtilesProtocol(): void {
  if (initialized || typeof window === 'undefined') return
  const protocol = new Protocol()
  addProtocol('pmtiles', protocol.tile.bind(protocol))
  initialized = true
}
